import { render, staticRenderFns } from "./ProjInfo.vue?vue&type=template&id=652d2564&"
import script from "./ProjInfo.vue?vue&type=script&lang=js&"
export * from "./ProjInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports